/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InputField } from '../../settings/fileUploaderPage/fileUploader.page.styled';
import SubmitButtonGroup from './submitButtonGroup';
import { validateContainerName } from '../../../utils/functions';
import { STORAGE_SOURCE } from '../../../constants/dataSources';

const AzureBlobForm = (props) => {
  const [inputValues, setInputValues] = useState({
    name: '',
    storageConnectionId: props?.storageConfigId,
    type: props.storageContainer,
    sourceType: STORAGE_SOURCE,
    params: {
      containerName: '',
    },
  });

  const [validationErrorLabel, setValidationErrorLabel] = useState('');

  const handleInputChange = (fieldName, value) => {
    setInputValues((prevState) => ({
      ...prevState,
      ...(fieldName.includes('.')
        ? { params: { ...prevState.params, [fieldName.split('.')[1]]: value } }
        : { [fieldName]: value }),
    }));
  };

  const clearValues = () => {
    setInputValues({
      name: '',
      storageConnectionId: props?.storageConfigId,
      type: props.storageContainer,
      params: {
        containerName: '',
      },
    });
  };

  const handleContainerNameBlur = () => {
    const validate = validateContainerName(inputValues.params.containerName, t);
    setValidationErrorLabel(validate);
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (props.storageConfigId) {
      setInputValues((prevState) => ({
        ...prevState,
        storageConnectionId: props?.storageConfigId,
      }));
    }
  }, [props.storageConfigId]);

  return (
    <>
      <InputField
        size="small"
        required
        fullWidth
        name="name"
        id="outlined-required"
        label={t('fileUploaderPage.storageConfiguration.newSourcePopover.name')}
        value={inputValues.name}
        onChange={(e) => handleInputChange('name', e.target.value)}
      />
      <InputField
        sx={{ marginTop: 2 }}
        size="small"
        fullWidth
        required
        name="containerName"
        id="outlined-required"
        label={t(
          'fileUploaderPage.storageConfiguration.newSourcePopover.containerName',
        )}
        value={inputValues.params.containerName}
        onChange={(e) =>
          handleInputChange('params.containerName', e.target.value)
        }
        onBlur={handleContainerNameBlur}
        helperText={validationErrorLabel}
        error={validationErrorLabel != '' ? true : false}
      />
      <SubmitButtonGroup
        data={inputValues}
        onClear={clearValues}
        errorMessage={validationErrorLabel}
      />
    </>
  );
};

AzureBlobForm.propTypes = {
  storageContainer: PropTypes.string,
  storageConfigId: PropTypes.string,
};

export default AzureBlobForm;
